<span class="lomy-points" [class.lomy-points--inherit]="inheritColor">
  <span class="lomy-points__value" *ngIf="!iconOnly && display">{{ display }}</span>
  <span
    class="lomy-points__coin"
    [style.width.px]="size"
    [style.height.px]="size"
    title="LOMY bod"
    aria-hidden="true"
  >
    <svg viewBox="0 0 17.911 18.247" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
      <path d="M10.425 1.258 L5.289 17.247 L16.911 17.247" />
      <path d="M1.025 8.941 L13.186 9.253" />
      <path d="M1.025 11.608 L13.186 11.92" />
    </svg>
  </span>
</span>
